module.exports = __webpack_public_path__ + "media/images/responsive/articles/icon_grand_title_search-6a8c0acf47ac13f4bf2797e09016fbf8.svg";